var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbox-size",class:{ 'active-size': _vm.isSizeActive },style:('background-image:url(' + _vm.imagePath(_vm.image) + ');'),on:{"click":_vm.setCanvasToolSize}})}
var staticRenderFns = []

export { render, staticRenderFns }